<template>
  <div class="video-container content-bg" :class="{
    isMobile: isMobile()
  }">    
    <div class="common-content-box sys-max-width">
      <div class="content">
        <div class="top-cat">
          <el-tabs v-model="secModuleId" @tab-click="handleCatClick">
            <el-tab-pane :key="index" v-for="(item, index) in videoModuleList" :label="item.name" :name="item.id"></el-tab-pane>
          </el-tabs>
        </div>

        <!-- 视频 -->
        <div class="video-box grid lg-mx lg:grid-cols-4 md:grid-cols-4 grid-cols-1 gap-8">
          <videoItem 
            v-for="(item, index) in videoList"
            :key="index"
            :item="item"
            @click="goDetail"
          />
        </div>
      </div>

      <!-- 分页 -->
      <div class="page text-center">
        <el-pagination
          background
          @current-change="currentPageChange"
          :current-page.sync="page"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { fetchAllVideoList, fetchVideoCate } from '@/api/video'

import moduleMixins from '@/mixins/module'
import pageMixins from '@/mixins/page'
import { isMobile } from '@/utils/index'
import videoItem from '@/components/videoItem'

export default {
  mixins: [moduleMixins, pageMixins],
  components: {
    videoItem
  },
  data() {
    return {
      moduleId: '', // 一级id
      secModuleId: '', // 二级id

      videoModuleList: [], // 视频分类
      videoList: [], // 视频列表

      pageSize: 16
    }
  },

  watch: {
    secModuleId(newVal) {
      if (newVal === '0') {
        return
      }

      // 重置页码
      this.page = 1

      this.getCommonContentList()
    }
  },


  methods: {
    isMobile,

    currentPageChange(e) {
      this.page = e

      this.getCommonContentList()

      // 滚动到顶部
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },

    handleCatClick(e) {
      console.log(e)

      this.$router.push({
        query: {
          ...this.$route.query,
          secId: this.secModuleId
        }
      })
    },

    goDetail(item) {
      console.log(item)
      this.$router.push({
        name: 'videoDetail',
        query: {
          id: item.id,
          video_code: item.video_code
        }
      })
    },

    async getCommonContentList() { // 请求二级下所有的视频
      try {
        const { list, total } = await fetchAllVideoList({
          page: this.page,
          pageSize: this.pageSize,
          category_id: this.secModuleId
        })

        this.videoList = list
        this.total = Number(total)
      } catch (error) {
        
      }
    },

    async getVideoModule() {
      try {
        const data = await fetchVideoCate()

        const fItem = data.find(i => i.id === this.moduleId)

        if (fItem) {
          this.videoModuleList = fItem.children || []
        }

      } catch (error) {
        console.log(error)
      }
    }
  },
  created() {
    const { id, secId } = this.$route.query

    this.moduleId = id
    this.secModuleId = secId

    if (this.moduleId && this.moduleId) {
      this.getVideoModule()
    }
  }
}
</script>

<style lang="scss">
.video-container {

  // &.isMobile {
  //   .video-item {
  //     .img {
  //       height: 195px;
  //     }
  //   }
  // }

  .video-hot-box {
    margin-bottom: 53px;
  }

  .video-box {
    margin-bottom: 53px;
  }

  .content {
    .top-cat {

      .el-tabs  {
        .el-tabs__item {
          font-size: 16px;
          color: #545c63;
          font-weight: 700;
        }

        .el-tabs__nav-wrap::after {
          display: none;
        }
      }
    }
  }
}
</style>